import type { ListQuery, OrganisationView, Page, PersonView, RecordView, SavedView, SavedViewInput, ViewField } from '@takeit4me/shared'
import type { Http } from '../http'

type In<T extends { _zod: { input: unknown } }> = T['_zod']['input']
export type ListQueryBody = In<typeof ListQuery>
export type SavedViewBody = In<typeof SavedViewInput>
export type ListItem = PersonView | OrganisationView | RecordView

/** Console API methods: workstream C (field filters, sorting, saved views, permissions). */
export interface ViewsApi {
  /** The columns a list can be filtered and sorted by, with their operators, for the signed-in viewer. */
  listFields(object: string): Promise<ViewField[]>
  /** One page of a filtered, sorted list (object: person, organisation or a custom object key). */
  queryList(object: string, body: ListQueryBody): Promise<Page<ListItem>>
  /** Saved views the viewer sees (shared, and their own), optionally for one object. */
  savedViews(object?: string): Promise<SavedView[]>
  getSavedView(id: string): Promise<SavedView>
  createSavedView(body: SavedViewBody): Promise<SavedView>
  /** Changes only the fields sent. */
  updateSavedView(id: string, body: Partial<SavedViewBody>): Promise<SavedView>
  deleteSavedView(id: string): Promise<{ ok: true }>
}

const enc = encodeURIComponent
export const viewsMethods = (http: Http): ViewsApi => ({
  listFields: (object) => http.get<ViewField[]>(`/crm/list/${enc(object)}/fields`),
  queryList: (object, body) => http.post<Page<ListItem>>(`/crm/list/${enc(object)}`, body),
  savedViews: (object) => http.get<SavedView[]>('/crm/views', { object }),
  getSavedView: (id) => http.get<SavedView>(`/crm/views/${enc(id)}`),
  createSavedView: (body) => http.post<SavedView>('/crm/views', body),
  updateSavedView: (id, body) => http.patch<SavedView>(`/crm/views/${enc(id)}`, body),
  deleteSavedView: (id) => http.delete<{ ok: true }>(`/crm/views/${enc(id)}`),
})
